import React, { useState, useEffect, useCallback } from "react";
import { useAuth } from "../context/AuthContext";
import PowerBIReport from "../components/PowerBIReport";
import ReportSelector from "../components/ReportSelector";
import axios from "axios";
import "./Dashboard.css";
import toast from "react-hot-toast";

function Dashboard() {
  const { user, logout } = useAuth();
  const [reports, setReports] = useState([]);
  const [selectedReport, setSelectedReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchReports = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.post(
        "https://sgoolfoto-backend.onrender.com/api/reports",
        {
          userIdentity: {
            email: user.email,
            roles: user.roles || [],
          },
          reportId: "23730628-8bee-4ed4-b1f1-19105e88ce3c",
        }
      );

      if (response.data.success) {
        setReports(response.data.reports);

        // Auto-select first report if available
        if (response.data.reports.length > 0) {
          setSelectedReport(response.data.reports[0]);
        }
      } else {
        setError("Failed to fetch reports");
      }
    } catch (err) {
      console.error("Error fetching reports:", err);
      setError(err.response?.data?.error || "Failed to connect to backend API");
    } finally {
      setLoading(false);
    }
  }, [user.email, user.roles]); // Dependencies for useCallback

  useEffect(() => {
    fetchReports();
  }, [fetchReports]); // Now includes fetchReports

  const handleReportSelect = (report) => {
    setSelectedReport(report);
  };

  const handleLogout = () => {
    logout();
    toast.success("Logged out successfully");
  };

  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <div className="header-content">
          <div className="header-left">
            <h1>Sgoolfotografie Dashboard</h1>
            <p>Welkom</p>
          </div>
          <div className="header-right">
            <div className="user-info">
              <div className="user-avatar">
                {user.username.charAt(0).toUpperCase()}
              </div>
              <div className="user-details">
                {/* <div className="user-name">{user.username}</div> */}
                <div className="user-email">{user.email}</div>
                {/* {user.roles && user.roles.length > 0 && (
                  <div className="user-roles">
                    {user.roles.map((role, idx) => (
                      <span key={idx} className="role-badge">
                        {role}
                      </span>
                    ))}
                  </div>
                )} */}
              </div>
              <button
                onClick={handleLogout}
                className="logout-btn"
                title="Logout"
              >
                Uitloggen
              </button>
            </div>
          </div>
        </div>
      </header>

      <main className="dashboard-main">
        {loading && (
          <div className="loading">
            <div className="spinner"></div>
            <p>Loading reports...</p>
          </div>
        )}

        {error && (
          <div className="error-container">
            <div className="error">
              <h2>⚠️ Error</h2>
              <p>{error}</p>
              <button onClick={fetchReports} className="retry-button">
                Retry
              </button>
            </div>
          </div>
        )}

        {!loading && !error && reports.length > 0 && (
          <div className="content-full">
            {/* TOP — REPORT SELECTOR */}
            {/* <ReportSelector
              reports={reports}
              selectedReport={selectedReport}
              onReportSelect={handleReportSelect}
            /> */}

            {/* FULL SCREEN REPORT */}
            <div className="report-fullscreen">
              {selectedReport && (
                <PowerBIReport
                  reportId={selectedReport.id}
                  reportName={selectedReport.name}
                  embedUrl={selectedReport.embedUrl}
                  datasetId={selectedReport.datasetId}
                />
              )}
            </div>
          </div>
        )}

        {!loading && !error && reports.length === 0 && (
          <div className="no-reports">
            <h2>No Reports Found</h2>
            <p>No reports are available in the workspace.</p>
          </div>
        )}
      </main>

      {/* <footer className="dashboard-footer">
        <p>Backend API: https://sgoolfoto-backend.onrender.com | Logged in as: {user.email}</p>
      </footer> */}
    </div>
  );
}

export default Dashboard;
